import { apiCall } from "../../../api-calls/api-call"
import {
  AccountBonusSpendStatus,
  AccountDailyMissionProgress,
  DailyMissionPostbackKind,
} from "../store/postbacks.store"
import { GamePlatformType } from "../store/account-games-BuffPlay.store"

// Per-game daily missions: tick + claim + read progress
export const tickDailyMissionForGame = async(
  accountId: string,
  gameId: string,
  kind: DailyMissionPostbackKind,
  platform: GamePlatformType,
) => {
  return apiCall({
    method: "POST",
    path: `admin/accounts/${accountId}/games/${gameId}/daily-missions/tick`,
    body: { kind, platform },
  })
}

// Account-level LOGIN_STREAK tick (no gameId — signal is account-wide).
// BE bypasses the once-per-day guard since this is a manual admin action.
export const tickAccountLoginStreak = async(
  accountId: string,
  platform: GamePlatformType,
) => {
  return apiCall({
    method: "POST",
    path: `admin/accounts/${accountId}/daily-missions/login-streak/tick`,
    body: { kind: "LOGIN_STREAK", platform },
  })
}

export const claimDailyMissionPostback = async(
  accountId: string,
  missionId: string,
) => {
  return apiCall({
    method: "POST",
    path: `admin/accounts/${accountId}/daily-missions/${missionId}/claim`,
  })
}

export const getAccountDailyMissionProgress = async(
  accountId: string,
  gameId: string,
  platform: GamePlatformType,
): Promise<AccountDailyMissionProgress[]> => {
  return apiCall({
    method: "GET",
    path: `admin/accounts/${accountId}/games/${gameId}/daily-missions/progress`,
    query: { platform },
  })
}

// Bonus Spend
export const applyAccountGameSpend = async(
  accountId: string,
  gameId: string,
  amount: number,
  platform: GamePlatformType,
) => {
  return apiCall({
    method: "POST",
    path: `admin/accounts/${accountId}/games/${gameId}/spend`,
    body: { amount, platform },
  })
}

export const claimBonusSpendMissionPostback = async(
  accountId: string,
  gameId: string,
  bonusSpendMissionId: string,
) => {
  return apiCall({
    method: "POST",
    path: `admin/accounts/${accountId}/games/${gameId}/bonus-missions/${bonusSpendMissionId}/claim`,
  })
}

export const getAccountBonusSpendStatus = async(
  accountId: string,
  gameId: string,
  platform: GamePlatformType,
): Promise<AccountBonusSpendStatus> => {
  return apiCall({
    method: "GET",
    path: `admin/accounts/${accountId}/games/${gameId}/bonus-spend/status`,
    query: { platform },
  })
}
